import DOMPurify from "dompurify";

/*
    Free text an expert types into a guide step goes to the logic builder as `interaction.data.text`,
    where flows can save it and render it elsewhere. The chat server sanitizes `data.text` (the trusted
    control); this is our own defense in depth. Strip all markup with the same DOMPurify config the Simplr
    chat widget applies to its own main input (`USE_PROFILES: { html: false }`). Its output stays
    HTML-encoded (`<` becomes `&lt;`) on purpose: decoding it would turn typed entities back into markup,
    and the chat server's sanitize-html encodes those characters the same way anyway.
*/
export const sanitizeFreeText = (text: string): string =>
    DOMPurify.sanitize(text, { USE_PROFILES: { html: false } }).trim();
